import { TFunction } from 'i18next';
import { GenericResponse } from 'src/js/model/api/response/generic-response';
import { ipv4, port } from 'src/js/validator/validator';
import * as yup from 'yup';

export enum NmosServiceState {
  CONNECTED = 'CONNECTED',
}

export interface NmosService {
  stats?: NmosServiceState;
  nodePort: number | string;
  mode: 'manual' | 'automatic';
  is04Address?: string;
  is04Port?: number | string;
  is09?: boolean;
  is09Address?: string;
  is09Port?: string;
  dnsIp?: string;
  domainName?: string;
  version?: string;
}

export interface NmosServiceResponse extends GenericResponse {
  data?: NmosService;
}

export interface NmosViewModel extends NmosService {}

export const mapNmosServices = (response: NmosService): NmosViewModel => ({
  ...response,
});

export const mapNmosViewModel = (model: NmosViewModel): NmosService => ({
  ...model,
});

/*
 * Validation
 */
export const nmosValidationSchema = (t: TFunction) =>
  yup.object().shape({
    nodePort: port(t),
    is04Address: yup.mixed().when('mode', {
      is: 'manual',
      then: ipv4(t).required(t('validation.required')),
    }),
    is04Port: yup.mixed().when('mode', {
      is: 'manual',
      then: port(t).required(t('validation.required')),
    }),
    is09Address: yup.mixed().when(['mode', 'is09'], {
      is: (mode, is09) => {
        return mode === 'manual' && is09 === true;
      },
      then: ipv4(t).required(t('validation.required')),
    }),
    is09Port: yup.mixed().when(['mode', 'is09'], {
      is: (mode, is09) => {
        return mode === 'manual' && is09 === true;
      },
      then: port(t).required(t('validation.required')),
    }),
  });
